module.exports = "<svg viewBox=\"0 0 50 50\"><circle cx=\"17.82\" cy=\"18.11\" r=\"16.21\"></circle><line x1=\"29.28\" y1=\"29.57\" x2=\"48.21\" y2=\"48.5\"></line></svg>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/graphcool-styles/icons/stroke/search.svg
// module id = 714
// module chunks = 0 1